/** @format */
import { decimalToCent } from '@toucan/client/global/currency';

import { FilterOption } from '@toucan/client/features/search/config/types';

import { MAX_CUSTOM_RANGE } from './constants';

export function serializeCustomRangeValue(
    value: string | number,
    convertFunction: (value: number) => number
) {
    if (!value || Number.isNaN(Number(value))) {
        return '';
    }

    return Math.min(convertFunction(Number(value)), MAX_CUSTOM_RANGE);
}

export function isSelected(
    option: FilterOption['value'],
    selectedOptions: FilterOption[]
) {
    return selectedOptions.some(
        (selectedOption) => selectedOption.value === option
    );
}

export function parseLowestAndHighestPriceOption(options: FilterOption[]) {
    const { lowest, highest, isContinuous } = options.reduce<{
        lowest: number[];
        highest: number[];
        isContinuous: boolean;
    }>(
        (priceOptions, option, index) => {
            const [low, high] = option.value.toString().split('-');

            // check the current low against the previous high to see if the range is continuous
            // e.g. 50-100, 100-150 is continuous but 50-100, 120-150 is not
            if (
                priceOptions.isContinuous &&
                index > 0 &&
                Number(low) !== priceOptions.highest[index - 1]
            ) {
                priceOptions.isContinuous = false;
            }

            if (low) {
                priceOptions.lowest.push(Number(low));
            }

            if (high) {
                priceOptions.highest.push(Number(high));
            }
            return priceOptions;
        },
        { lowest: [], highest: [], isContinuous: true }
    );

    return {
        lowest: Math.min(...lowest),
        highest: Math.max(...highest),
        isContinuous,
    };
}

export function getCustomRangeItem(from: string | number, to: string | number) {
    const serializedFrom = serializeCustomRangeValue(from, decimalToCent);
    const serializedTo = serializeCustomRangeValue(to, decimalToCent);

    if (serializedFrom || serializedTo) {
        return { value: `${serializedFrom || 0}-${serializedTo}` };
    }

    return null;
}

export function onCustomRangeInputKeyPress(
    event: React.KeyboardEvent<HTMLInputElement>
) {
    // HTML number inputs still allow these keys although here we don't want to
    const disallowedKeys = ['e', '-', '+'];

    if (disallowedKeys.includes(event.key)) {
        event.preventDefault();
    }
}
